// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1AStk","visuallyhidden":"_1Oodr","hide-text":"K9VzI","center":"_1PId6","noprint":"_1RYFT","root":"_2Y-7H","contentContainer":"_1lO2Y","noA":"_3fX7P"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/theme/article/sports.scss
 ** module id = 977
 ** module chunks = 2
 **/